import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import { Button, Form, Radio, Input } from "antd";
import { useMutation } from "react-query";
import { show_toast } from "utils/helpers";
import { ModalContext } from "context/ModalContext";
import { close_lead } from "services/apiSrv";
import routes from "routes";
import { useHistory } from "react-router-dom";

const CloseRemarks = (props) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { modalClose } = useContext(ModalContext);
  const history = useHistory();

  const _close = useMutation(close_lead, {
    onSuccess: (data) => {
      modalClose();
      show_toast("Lead closed successfully", "success");
      history.push(routes.leads);
    },
    onError: async (error) => {
      modalClose();
    },
  });

  const onFinish = (values) => {
    let data = {
      lead_ref: props.lead_ref,
      business_ref: values.success,
      remarks: values.remarks,
    };
    _close.mutate(data);
  };
  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Close Lead</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form layout="vertical" form={form} onFinish={onFinish}>
            <Form.Item
              label="Was Business Successful"
              name="success"
              rules={[{ required: true, message: "Option is required" }]}
            >
              <Radio.Group>
                <Radio value="business_success">Yes</Radio>
                <Radio value="business_unsuccessful">No</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label="Closing Remarks"
              name="remarks"
              rules={[
                { required: true, message: "Closing Remarks are required" },
              ]}
            >
              <TextArea rows={3} />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                disabled={_close.isLoading}
              >
                {_close.isLoading ? (
                  <>
                    <i
                      className="fa fa-circle-notch fa-spin text-white"
                      style={{ marginRight: "5px" }}
                    />
                    Loading..
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            </Form.Item>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CloseRemarks;
